var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ expanded: !_vm.hidden }},[_vm._t("default"),_vm._v(" "),(_vm.hidden > 0)?_c('span',{staticClass:"navigation__more",on:{"click":_vm.expand}},[_vm._v("Show "+_vm._s(_vm.hidden)+" more")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }